import React from 'react'

export default function Privacy() {
  return (
    <div className="bg-gray-100 rounded-t-3xl px-6 pt-32 lg:px-8">
      <div className="mx-auto max-w-3xl text-base leading-7 text-gray-700">
        <h1 class="text-3xl font-bold mb-4"> Privacy Policy</h1>
        <p class="mb-4">Effective Date: November 4, 2024</p>

        <hr class="my-6 border-t border-gray-300" />

        <h2 class="text-2xl font-bold mb-2">Introduction</h2>
        <p class="mb-4">At Lekker Melodies, I understand the importance of protecting your privacy. As a provider of an individual app for listening to nature sounds and ambient sounds, I'm committed to being transparent about our data practices and ensuring the security of any personal information you may share.</p>

        <h2 class="text-2xl font-bold mb-2">No Data Collection</h2>
        <p class="mb-4">I am proud to inform you that Lekker Melodies does not require any sign-up or sign-in, and the site do not collect any personal data from users. You can freely use the app without the need to provide any information. I believe in respecting your privacy and giving you a seamless and secure experience.</p>

        <h2 class="text-2xl font-bold mb-2">Contact Information</h2>
        <p class="mb-4">If you have any questions or concerns about the privacy practices, you can reach out to me through the any  of the social hanndles provided on the <a href="https://lekkermelodies.com/#about" className="text-blue-500 hover:text-blue-700">About page</a> of this website. I am committed to addressing any inquiries or issues you may have in a timely and professional manner.</p>

        <h2 class="text-2xl font-bold mb-2">Changes to this Privacy Policy</h2>
        <p class="mb-4">I may update this Privacy Policy from time to time to ensure it remains accurate and relevant. Any changes will be posted on website, and the updated version will be effective upon posting. I encourage you to review this policy periodically to stay informed about data practices.</p>

        <h2 class="text-2xl font-bold mb-2">Conclusion</h2>
        <p class="mb-14">At Lekker Melodies, your privacy is of the utmost importance to me. I am dedicated to providing a secure and transparent experience for all our users. If you have any further questions or concerns, please don't hesitate to reach out. I'm here to assist you and ensure your experience with Lekker Melodies is a positive one.</p>
        <hr class="my-6 border-t border-gray-300" />
        <br/>
      </div>
    </div>
  )
}
